import React from 'react';

const NotFoundPage = () => (
  <div>
    <h3>
      Invalid Page
    </h3>
  </div>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/NotFoundPage/index.js